document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    if (document.body.getAttribute("data-test-recolation-pdp") !== "true") return;

    const source = document.querySelector("#product-description");
    const targetSection = document.querySelector(".product-roast-type");
    const description = source?.querySelector(".about-content");
    const footerInfo = source?.querySelector(".footer-info");

    const subtitle = source?.querySelector(".subtitle-product");
    const title = source?.querySelector(".about-trigger");

    const containerDescription = targetSection?.querySelector(".container");

    if (source && targetSection && containerDescription && description) {

      const newDivHeading = document.createElement("div");
      newDivHeading.className = "product-heading container container--ml";

      if (subtitle) newDivHeading.appendChild(subtitle.cloneNode(true));
      if (title) newDivHeading.appendChild(title.cloneNode(true));

      const newDivDescription = document.createElement("div");
      newDivDescription.className = "extra-description container container--ml";
      newDivDescription.innerHTML = description.innerHTML;

      if (footerInfo) {
        newDivDescription.innerHTML += footerInfo.outerHTML;
      }

      targetSection.insertAdjacentElement("afterbegin", newDivHeading);

      containerDescription.insertAdjacentElement("afterend", newDivDescription);

      source.style.display = "none";
    }
  }, 800);
});
